module.exports = ".ngx-editor-message{font-size:80%;background-color:#f1f1f1;border:1px solid #ddd;border-top:transparent;padding:0 0.5rem;padding-bottom:0.1rem;-webkit-transition:0.5s ease-in;transition:0.5s ease-in}\n"


//////////////////
// WEBPACK FOOTER
// ./src/externals/ngx-editor/src/ngx-editor-message/ngx-editor-message.component.scss
// module id = ./src/externals/ngx-editor/src/ngx-editor-message/ngx-editor-message.component.scss
// module chunks = main